export default "__VITE_ASSET__ozzfpHgT__"